import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { SelectBankTypePage } from './select-bank-type';

@NgModule({
  declarations: [
    SelectBankTypePage,
  ],
  imports: [
    IonicPageModule.forChild(SelectBankTypePage),
  ],
})
export class SelectBankTypePageModule {}



// WEBPACK FOOTER //
// ./src/pages/select-bank-type/select-bank-type.module.ts